<template>
  <header-page-layout page-title="Debug Console">

    <b-container>
      <b-row>
        <b-col lg="3">
          <b-button
            variant="danger"
            @click="mangleUserToken"
          >Mangle Auth Token</b-button>
        </b-col>

        <b-col>
          Replace the auth token with one that's expired to test 401 Unauthorized requests
        </b-col>
      </b-row>
    </b-container>

  </header-page-layout>
</template>

<script>
import { mapActions } from 'vuex'
import HeaderPageLayout from '../components/HeaderPageLayout'

export default {
  components: {
    HeaderPageLayout
  },

  methods: {
    ...mapActions([
      'mangleUserToken'
    ])
  }
}
</script>
